import axios from 'axios';
import { UPDATE_STEP_ONE } from '../paths';

export const updateStep1 = (data, courseID) => {
  const { title, description, duration, category, contentType, tags, zone } = data;

  const body = {
    courseID,
    title,
    desc: description,
    contentType: contentType?._id,
    duration,
    tags: tags.map(({ _id }) => _id),
    category: category._id,
    zone: [zone?.value],
  };
  const response = axios.post(UPDATE_STEP_ONE, body);
  return response;
};
